import React from 'react'
import Online_table from '../../../Online_table/Online_table'

const OnlineTable = () => {
  return (
    <Online_table />
  )
}

export default OnlineTable